import { render } from "./Email_Integrations.vue?vue&type=template&id=044a202a"
import script from "./Email_Integrations.vue?vue&type=script&lang=js"
export * from "./Email_Integrations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__